export class EmpowerData {
  state: string;
  county?: string;
  fipsCode?: string;
  beneficiaries: number;
  energyDependant: number;
  healthcareService: number;
  atHomeHospice: number;
  firstStateFips: string;
  facilityDialysis: number;
  homeHealth: number;
  name: string;
  anyServices: number;
  objectId: number;
  objectId_1: number;
  powerDe_1: number;
  shapeArea: number;
  shapeLength: number;
  stateAbbreviation: string;


  constructor(data: Record<string, unknown>) {
    this.state = data['State'] as string;
    this.stateAbbreviation = data['State'] as string;
    this.county = data['County'] as string | undefined;
    this.beneficiaries = data['Medicare_Benes'] as number;
    this.fipsCode = (data['FIPS_Code'] || data['county_fips']) as string | undefined;
    this.energyDependant = data['Power_Dependent_Devices_DME'] as number;
    this.healthcareService = data['Any_Healthcare_Srvc_Any_DME'] as number;
    this.atHomeHospice = data['AtHome_Hospice_Any_DME'] as number;
    this.firstStateFips = data['FIRST_State_FIPS_Code'] as string;
    this.facilityDialysis = data['Facility_ESRD_Dialysis_Any_DME'] as number;
    this.homeHealth = data['Home_Health_Services_Any_DME'] as number;
    this.anyServices = data['O2_Services_Any_DME'] as number;
    this.objectId = data['OBJECTID'] as number;
    this.objectId_1 = data['OBJECTID_1'] as number;
    this.powerDe_1 = data['Power_De_1'] as number;
    this.shapeArea = data['Shape__Area'] as number;
    this.shapeLength = data['Shape__Length'] as number;


    if (this.county) {
      this.name = `${this.county} (${this.state})`;
    } else if (this.state) {
      this.name = this.state;
    } else {
      this.name = 'Not Available';
    }
  }
}
